<template>
  <div class="annualContainer">
    <!-- 客服二维码弹框 -->
    <div class="qrcodeDialog" v-if="showQrcodeDialog">
      <div class="mask" @click="closeQrcodeDialog"></div>
      <div class="dialogContent">
        <div class="closeBtn" @click="closeQrcodeDialog">×</div>
        <div class="qrcodeTitle">添加客服微信</div>
        <img class="qrcodeImg" :src="currentQrcode" alt="客服二维码" />
      </div>
    </div>
    <!-- 内容区域 -->
    <div class="annualWrap">
      <!-- 基础版套餐（移除top，仅保留背景图） -->
      <div
        class="packageItemExtWrap"
        :style="{ backgroundImage: 'url(' + bgBasic + ')' }"
      >
        <div class="packageItemWrap">
          <div class="basicMain">
            <img class="main" src="@/assets/images/main1.gif" alt="主图" />
            <div class="basicWrap">
              <span class="title">基础版套餐</span>
              <div class="descn">
                支持100人以内活动需求，标配基础的签到，大屏互动环节。
              </div>
              <div class="price"><span>¥</span>298<span>/场</span></div>
              <span class="priceTip">原价588/场</span>
              <div class="submit" @click="openQrcodeDialog">立即抢购</div>
            </div>
          </div>
          <span class="tcTitle">套餐特色</span>
          <div class="tcTagWrap">
            <div class="tag">签到</div>
            <div class="tag">聚宝盆</div>
            <div class="tag">红包雨</div>
            <div class="tag">竞技</div>
            <div class="tag">财神到</div>
            <div class="tag">摇一摇</div>
          </div>
          <div class="tcPicWrap">
            <img src="@/assets/images/11.gif" alt="" /><img
              src="@/assets/images/12.gif"
              alt=""
            /><img src="@/assets/images/16.gif" alt="" />
            <img src="@/assets/images/14.gif" alt="" /><img
              src="@/assets/images/15.gif"
              alt=""
            /><img src="@/assets/images/13.gif" alt="" />
          </div>
        </div>
      </div>

      <!-- 畅玩套餐（移除top，保留背景图+内边距） -->
      <div
        class="packageItemExtWrap"
        style="padding-bottom: 40px"
        :style="{ backgroundImage: 'url(' + bgFun + ')' }"
      >
        <div class="packageItemWrap">
          <div class="basicMain">
            <img class="main" src="@/assets/images/main2.gif" alt="主图" />
            <div class="basicWrap">
              <span class="title">畅玩版套餐</span>
              <div class="descn">
                支持500人以内活动需求，开放所有竞技类游戏功能，增添多种抽奖形式。
              </div>
              <div class="price"><span>¥</span>498<span>/场</span></div>
              <span class="priceTip">原价888/场</span>
              <div class="submit" @click="openQrcodeDialog">立即抢购</div>
            </div>
          </div>
          <span class="tcTitle">套餐特色</span>
          <div
            class="tcTagWrap"
            style="
              grid-template-columns: repeat(3, 1fr);
              grid-template-rows: repeat(1, 1fr);
            "
          >
            <div class="tag" style="padding: 0 5px">基础版全部功能</div>
            <div class="tag" style="padding: 0 5px">小游戏</div>
            <div class="tag" style="padding: 0 5px">抽奖</div>
          </div>
          <div class="tcPicWrap">
            <img src="@/assets/images/21.gif" alt="" /><img
              src="@/assets/images/22.gif"
              alt=""
            /><img src="@/assets/images/23.gif" alt="" />
            <img src="@/assets/images/24.gif" alt="" /><img
              src="@/assets/images/25.gif"
              alt=""
            /><img src="@/assets/images/26.gif" alt="" />
          </div>
        </div>
      </div>

      <!-- 高定套餐（移除top，保留背景图+内边距） -->
      <div
        class="packageItemExtWrap"
        style="padding-bottom: 70px"
        :style="{ backgroundImage: 'url(' + bgGd + ')' }"
      >
        <div class="packageItemWrap">
          <div class="basicMain">
            <img class="main" src="@/assets/images/main2.gif" alt="主图" />
            <div class="basicWrap">
              <span class="title">高定版套餐</span>
              <div class="descn">
                支持1000人以内活动需求，增添企业专属logo，公众号吸粉等专属定制功能。
              </div>
              <div class="price"><span>¥</span>888<span>/场</span></div>
              <span class="priceTip">原价1288/场</span>
              <div class="submit" @click="openQrcodeDialog">立即抢购</div>
            </div>
          </div>
          <span class="tcTitle">套餐特色</span>
          <div
            class="tcTagWrap"
            style="
              grid-template-columns: repeat(2, 1fr);
              grid-template-rows: repeat(2, 1fr);
            "
          >
            <div class="tag" style="padding: 0 5px">畅玩版全部功能</div>
            <div class="tag" style="padding: 0 5px">签到定制</div>
            <div class="tag" style="padding: 0 5px">其他部分定制功能</div>
            <div class="tag" style="padding: 0 5px">公众号吸粉</div>
          </div>
          <div class="tcPicWrap">
            <img src="@/assets/images/21.gif" alt="" /><img
              src="@/assets/images/22.gif"
              alt=""
            /><img src="@/assets/images/23.gif" alt="" />
            <img src="@/assets/images/24.gif" alt="" /><img
              src="@/assets/images/25.gif"
              alt=""
            /><img src="@/assets/images/26.gif" alt="" />
          </div>
        </div>
      </div>

      <!-- 经典案例（移除top） -->
      <div class="featureWrap" style="padding-bottom: 10px">
        <div class="title">经典案例</div>
        <div class="subTitle">不一样的场合，一样的精彩</div>
        <div class="featureContent">
          <div class="featureItem">
            <img src="~@/assets/images/case/case1.jpg" alt="" /><span
              class="caseTitle"
              >FLUOR年会</span
            >
          </div>
          <div class="featureItem">
            <img src="~@/assets/images/case/case2.jpg" alt="" /><span
              class="caseTitle"
              >上海华瑞银行年会</span
            >
          </div>
          <div class="featureItem">
            <img src="~@/assets/images/case/case3.jpg" alt="" /><span
              class="caseTitle"
              >中国人保客户答谢会</span
            >
          </div>
          <div class="featureItem">
            <img src="~@/assets/images/case/case4.jpg" alt="" /><span
              class="caseTitle"
              >友邦北京分公司新品推介会</span
            >
          </div>
          <div class="featureItem">
            <img src="~@/assets/images/case/case5.jpg" alt="" /><span
              class="caseTitle"
              >国航空客C919品鉴会</span
            >
          </div>
          <div class="featureItem">
            <img src="~@/assets/images/case/case6.jpg" alt="" /><span
              class="caseTitle"
              >法拉利俱乐部</span
            >
          </div>
          <div class="featureItem">
            <img src="~@/assets/images/case/case7.jpg" alt="" /><span
              class="caseTitle"
              >海尔够够花消费金融推介会</span
            >
          </div>
          <div class="featureItem">
            <img src="~@/assets/images/case/case8.jpg" alt="" /><span
              class="caseTitle"
              >谦奕优秀员工表彰会</span
            >
          </div>
        </div>
      </div>

      <!-- 嗨动优势（移除top） -->
      <div class="featureWrap" style="padding-bottom: 10px">
        <div class="title">嗨动优势</div>
        <div class="subTitle">坚持以用户为中心，追求卓越，永不止步</div>
        <div class="advantage">
          <div class="item">
            <img src="@/assets/images/function1.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/images/function2.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/images/function3.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/images/function4.png" alt="" />
          </div>
        </div>
      </div>

      <!-- 在线咨询（移除top） -->
      <div
        class="consultWrap"
        @click="openQrcodeDialog"
        style="padding-bottom: 10px"
      >
        <img src="@/assets/images/icon_chat.png" alt="在线咨询" /><span
          >在线咨询</span
        >
      </div>
    </div>
    <!-- 导航按钮 -->
    <div class="goTop" @click="goToTop">
      <img src="@/assets/images/icon_2top.png" alt="回到顶部" />
    </div>
  </div>
</template>

<script>
// 移除：swiper冗余引入（页面无swiper，可删）
export default {
  name: "annualPackage",
  data() {
    return {
      // 移除：登录/注册相关变量
      bgBasic: require("@/assets/images/bg_basic.png"),
      bgFun: require("@/assets/images/bg_cw.png"),
      bgGd: require("@/assets/images/bg_gd.png"),
      showQrcodeDialog: false,
      currentQrcode: "",
      qrcodeList: [
        require("@/assets/images/kf1.png"),
        require("@/assets/images/kf2.png"),
        require("@/assets/images/kf3.png"),
      ],
      // 新增：案例数据抽离（方便维护，移动端复用）
      caseList: [
        { img: "~@/assets/images/case/case1.jpg", name: "FLUOR年会" },
        { img: "~@/assets/images/case/case2.jpg", name: "上海华瑞银行年会" },
        { img: "~@/assets/images/case/case3.jpg", name: "中国人保客户答谢会" },
        {
          img: "~@/assets/images/case/case4.jpg",
          name: "友邦北京分公司新品推介会",
        },
        { img: "~@/assets/images/case/case5.jpg", name: "国航空客C919品鉴会" },
        { img: "~@/assets/images/case/case6.jpg", name: "法拉利俱乐部" },
        {
          img: "~@/assets/images/case/case7.jpg",
          name: "海尔够够花消费金融推介会",
        },
        { img: "~@/assets/images/case/case8.jpg", name: "谦奕优秀员工表彰会" },
      ],
    };
  },
  methods: {
    // 新增：回到顶部核心方法
    goToTop() {
      // 平滑滚动到页面顶部，x轴0，y轴0
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    // 二维码弹框（保留原有逻辑，适配移动端）
    openQrcodeDialog() {
      const randomIndex = Math.floor(Math.random() * this.qrcodeList.length);
      this.currentQrcode = this.qrcodeList[randomIndex];
      this.showQrcodeDialog = true;
      document.body.style.overflow = "hidden";
    },
    closeQrcodeDialog() {
      this.showQrcodeDialog = false;
      document.body.style.overflow = "auto";
    },
  },
};
</script>

<style scoped lang="less">
// 🔥 全局变量：间距直接翻倍，可自行修改数值
:root {
  --section-margin: 80px; /* 原40px → 80px（间距翻倍） */
  --section-width: 344px;
}

// 全局移动端适配
.annualContainer {
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-right: 0 !important;
  overflow-x: hidden;
  background: linear-gradient(180deg, #ffe8eb 0%, #fff5f6 84.97%, #ffffff 100%);
  min-height: 100vh;
  height: auto;

  .annualWrap {
    width: 100%;
    background-image: url("~@/assets/images/bg_annual.png");
    background-repeat: no-repeat;
    background-position: top center; /* 背景图贴顶部居中 */
    // 🔥 修复发糊：宽度100%铺满，高度按原图比例，绝不拉伸
    background-size: 100% auto;
    padding: 235px 10px 40px; /* 还原你原来的顶部内边距，对齐顶部背景 */
    flex-shrink: 0;
    box-sizing: border-box;

    // 所有板块公共流式布局（居中+统一间距）
    .packageItemExtWrap,
    .featureWrap,
    .consultWrap {
      width: var(--section-width);
      margin: 0 auto;
      margin-top: var(--section-margin);
      box-sizing: border-box;
    }
    .packageItemExtWrap:first-child {
      margin-top: 0;
    }

    // ====================== 以下代码完全不动，保留你原有样式 ======================
    .packageItemExtWrap {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      min-height: 721px;
      height: auto;
      padding: 17px 12px 80px;
      box-sizing: border-box;
      // border: 1px solid #fa332b;
      margin-top: 40px;

      .packageItemWrap {
        margin: 80px auto 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        padding: 0 8px;

        .basicMain {
          background-color: #fff;
          width: 270px;
          height: 300px;
          padding: 15px;
          box-sizing: border-box;
          border: 1px solid #ff4216;
          border-radius: 10px;
          .main {
            width: 240px;
            height: 138px;
            border-radius: 8px;
            border: 1px solid #f68f20;
          }

          .basicWrap {
            position: relative;
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            font-weight: 500;
            color: #000000;
            padding: 6px 8px;
            box-sizing: border-box;
            .title {
              font-size: 18px;
              line-height: 25px;
            }
            .descn {
              font-weight: 500;
              font-size: 13px;
              color: #000000;
              line-height: 18px;
              text-align: left;
            }
            .price {
              margin-top: 12px;
              font-weight: 500;
              font-size: 26px;
              color: #fc332b;
              line-height: 18px;
              text-align: left;
              span {
                font-size: 13px;
              }
            }
            .priceTip {
              font-weight: 500;
              font-size: 13px;
              color: #999999;
              line-height: 18px;
              text-align: left;
            }
            .submit {
              width: 96px;
              height: 35px;
              background: linear-gradient(360deg, #fa332b 0%, #f78329 100%);
              border-radius: 19px;
              font-weight: 500;
              font-size: 15px;
              color: #ffffff;
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              right: 26px;
              bottom: 19px;
            }
          }
        }

        .tcTitle {
          font-weight: 500;
          font-size: 18px;
          color: #000000;
          line-height: 25px;
          margin-top: 14px;
        }

        .tcTagWrap {
          width: 240px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-template-rows: repeat(2, 1fr);
          gap: 8px;
          margin-top: 18px;
          box-sizing: border-box;
          .tag {
            font-weight: 500;
            font-size: 16px;
            color: #fc332b;
            background: #fef8f9;
            border: 1px solid #fc332b;
            border-radius: 6px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 3px 0;
            white-space: nowrap;
          }
        }

        .tcPicWrap {
          width: 270px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 8px;
          margin-top: 18px;
          box-sizing: border-box;
          img {
            width: 126px;
            height: 70px;
            border-radius: 4px;
          }
        }
      }
    }

    .featureWrap {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      // border: 1px solid #f68f20;
      padding: 15px;
      box-sizing: border-box;
      margin-bottom: 40px;
      .title {
        font-weight: 600;
        font-size: 20px;
        color: #333333;
        line-height: 28px;
        text-align: center;
        margin-bottom: 4px;
      }
      .subTitle {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        text-align: center;
        margin-bottom: 14px;
      }
      .featureContent {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 14px;
        .featureItem {
          width: 152px;
          min-height: 109px;
          border-radius: 0 0 4px 4px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          background-color: #fff;
          span {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-weight: 500;
            font-size: 13px;
            color: #000000;
            line-height: 18px;
            padding: 2px 8px;
          }
          img {
            width: 152px;
            height: 86px;
          }
        }
      }
      .advantage {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 12px;
        width: 100%;
        box-sizing: border-box;
        .item {
          flex: 0 0 calc(50% - 6px);
          max-width: calc(50% - 6px);
          box-sizing: border-box;
          overflow: hidden;
          img {
            width: 100%;
            height: auto;
            aspect-ratio: 152/180;
          }
        }
      }
    }

    .consultWrap {
      cursor: pointer;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #eb698f;
      line-height: 20px;
      background-color: #fff;
      border-top: 1px solid #f3f3f3;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 99;
      width: auto !important;
      margin: 0 !important;
      border-radius: 0;
      img {
        width: 18px;
        height: 16px;
        margin-right: 6px;
      }
    }
  }

  // 新增：回到顶部按钮样式 - 满足48X48、右侧固定、垂直居中
  .goTop {
    position: fixed;
    right: 11px; // 右侧完全靠边
    top: 70%; // 垂直居中基准
    transform: translateY(-50%); // 向上偏移自身50%，实现精准垂直居中
    z-index: 999; // 遮挡层级（低于全局加载的9999，避免遮挡加载层）
    cursor: pointer; // 鼠标悬浮手型，提升交互体验

    img {
      width: 48px;
      height: 48px;
      object-fit: contain; // 防止图片拉伸变形
    }
    // 可选：点击反馈，提升交互体验
    &:active {
      opacity: 0.8;
      transform: translateY(-50%) scale(0.95);
    }
  }

  // 二维码弹框（完全不变）
  .qrcodeDialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;

    .mask {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
    }

    .dialogContent {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #ffffff;
      border-radius: 12px;
      padding: 20px 15px;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 80%;
      max-width: 300px;

      .closeBtn {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 20px;
        color: #999;
        cursor: pointer;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          color: #fc332b;
          transform: rotate(90deg);
          transition: all 0.2s ease;
        }
      }

      .qrcodeTitle {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 15px;
        text-align: center;
      }

      .qrcodeImg {
        width: 100%;
        height: auto;
        border: 1px solid #eee;
        padding: 8px;
        border-radius: 6px;
      }
    }
  }
}
</style>
